<div class="tt-sidebar-references_header">
  <span>{{ 'References' | transloco }}:</span>
  <button aria-label="Add literature button" emphasis="minimal" size="icon" ttButton variant="primary" (click)="addReference($event)">
    <mat-icon [icon]="'circle-plus-filled'" [iconSize]="18" />
  </button>
</div>

@if (referencesWithNumbers()?.length > 0) {
  <div class="tt-sidebar-references_list">
    @for (reference of referencesWithNumbers(); track reference.id) {
      <tt-reference-card
        [deletable]="true"
        [editable]="true"
        [reference]="reference"
        (deleteReference)="deleteReference($event)"
        (editReference)="editReference($event)" />
    }
  </div>
}
